import {
  ALL_EVENTS,
  AWAITING_TO_TRACE,
  CANCELLED_EVENTS,
  COLLECTION_CENTRES,
  COMPLETED_EVENTS,
  EVENT_REPORT,
  FARM_DETAILS,
  FARMER_DETAILS,
  FARMER_REPORT,
  FARMERS,
  FFB_DETAILS,
  INVITE_SENT,
  ONGOING_EVENTS,
  ORGANISATIONS,
  PARTICIPANT_REPORT,
  PLANTATION,
  POSTPONED_EVENTS,
  registered,
  REGISTERED,
  SURVEY_REPORT,
  TRACE_TO_PLANTATION,
  TRACE_TO_VERIFY,
  training_approved,
  TRAINING_LESSON,
  UPCOMING_EVENTS,
  UPLOADED_REPORT,
  WORKER_DETAILS,
  FARM_REPORT,
  TTP_DATA_REPORT,
  DOCUMENTS_REPORT,
  APPROVAL_REPORT,
  ELIGIBLE,
  PARTIALLYELIGIBLE,
  VERIFY_FARMER,
  AUDIT_REVIEW,
  AUDIT_COMPLETION,
  ADD_DATA,
  ADD_DOCUMENTS,
  Farmer_CcReport,
  Farm_CcReport,
  FFB_CcReport,
  Fertilizer_CcReport,
  Chemical_CcReport,
  Expenses_CcReport,
  Worker_CcReport,
  Training_CcReport,
  Premium_Calculation_CcReport,
  Uploaded_Report_CcReport,
  TRAINING_COMPLETION,
  REGISTRATION,
  DIFFUSION,
  TV,
  CC,
  LIVELIHOOD,
} from './constants';

export const COLUMN_ALIASES = {
  participantName: ['Participant Name', 'participant name', 'PARTICIPANT NAME', 'Name', 'name'],
  participantEmail: [
    'Participant Email',
    'participant email',
    'PARTICIPANT EMAIL',
    'Email',
    'email',
  ],
  phoneNumber: [
    'Phone Number',
    'Phone number',
    'phone number',
    'Contact',
    'contact',
    'Phone',
    'phone',
    'number',
  ],
  gender: ['Gender', 'gender', 'GENDER'],
  participantAge: ['Age', 'age', 'AGE'],
  participantICNumber: ['IC Number', 'ic number', 'IC NUMBER', 'IC number'],
  typesOfParticipant: ['Type of Participant', 'type of participant', 'participantType'],
  eventParticipationMode: ['Event Participation', 'event participation'],
  participantStatus: ['Participant Status', 'participant status', 'participantStatus'],
  organisation: ['Organisation', 'organisation', 'Organization', 'organization'],
  collectionCenter: [
    'Collection Center',
    'collection center',
    'Collection center',
    'Collection Centre',
    'collection centre',
    'Collection centre',
    'collectionCentre',
    'collectionCenter',
  ],
  Question: ['Question', 'question'],
  InputType: ['Input Type', 'input type', 'inputType'],
  status: ['Status', 'status', 'Active/ Inactive', 'active/inactive'],
  Mandatory: ['Mandatory', 'mandatory', 'mandatory'],
  AnswerOptions: ['Answer Options', 'answer options', 'answerOptions', 'options'],
  SurveyResponse: ['Survey Response', 'survey response', 'surveyResponse'],
  FFBProductionVolume: ['FFBProductionVolume', 'ffbproductionvolume'],
  FFBDeliveryDate: ['FFBDeliveryDate', 'ffbdeliverydate'],
};

export const ACTIVE_INACTIVE_LIST = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
];
export const STATUS_LIST = [
  { label: 'completed', value: 1 },
  { label: 'ongoing', value: 2 },
  { label: 'upcoming', value: 3 },
  { label: 'cancelled', value: 4 },
  { label: 'postponed', value: 5 },
  { label: 'draft', value: 6 },
];

export const COMPLETION_DROPDOWN_LIST = [
  { label: 'Yes', value: 'completed' },
  { label: 'No', value: 'not_completed' },
];

export const STATUS_DROPDOWN_LIST = [
  {
    label: 'upcoming',
    value: 'upcoming',
    flag: ['ongoing', 'completed', 'cancelled', 'postponed'],
  },
  { label: 'ongoing', value: 'ongoing', flag: ['upcoming', 'completed', 'cancelled', 'postponed'] },
  {
    label: 'completed',
    value: 'completed',
    flag: ['upcoming', 'ongoing', 'cancelled', 'postponed'],
  },
  {
    label: 'cancelled',
    value: 'cancelled',
    flag: ['upcoming', 'ongoing', 'completed', 'postponed'],
  },
  {
    label: 'postponed',
    value: 'postponed',
    flag: ['upcoming', 'ongoing', 'completed', 'cancelled'],
  },
];

export const EVENT_BADGE_DROPDOWN_LIST = [
  { label: 'Event Started', value: 'event_started', flag: [''] },
  {
    label: 'Pre Survey Started',
    value: 'pre_survey_started',
    flag: ['demographic_survey_started'],
  },
  {
    label: 'Post Survey Started',
    value: 'post_survey_started',
    flag: ['training_started'],
  },
  // { label: "Demographic Survey Started", value: "demographic_survey_started", flag: ['attendance_started'] }, // edited as UI/UX given image
  // { label: "Consent Of Survey Started", value: "consent_of_survey_started", flag: ['attendance_started'] },
  {
    label: 'Training Started',
    value: 'training_started',
    flag: ['pre_survey_started'],
  },
  {
    label: 'Attendance Started',
    value: 'attendance_started',
    flag: ['post_survey_started'],
  },
  // { label: "Completed Event", value: "completed_event", flag: ['attendance_started'] }
];

export const EventsCol = [
  { label: 'S.No' },
  { label: 'Event ID' },
  { label: 'Event Name' },
  { label: 'Date', sortable: 'eventDate' },
  { label: 'Location' },
  { label: 'Event Mode' },
  { label: 'Training Mode', sortable: 'trainingMode' },
  { label: 'Module' },
  { label: 'Status' },
  { label: 'Action' },
];
export const CCEventsCol = [
  { label: 'S.No' },
  { label: 'Event ID' },
  { label: 'Event Name' },
  { label: 'Date', sortable: 'eventDate' },
  { label: 'Location' },
  { label: 'Event Mode' },
  { label: 'Training Mode', sortable: 'trainingMode' },
  { label: 'Event Type' },
  { label: 'Module' },
  { label: 'Status' },
  { label: 'Action' },
];
export const EventSurveyCol = [
  { label: 'S.No' },
  { label: 'Event ID' },
  { label: 'Event name' },
  { label: 'Date', sortable: 'eventDate' },
  { label: 'Location' },
  { label: 'Survey Type' },
  { label: 'Survey Responses' },
  { label: 'Module' },
  { label: 'Participant count', sortable: 'participantattened' },
  { label: 'Forms received', sortable: 'surveySubmittedCount' },
  { label: 'Forms pending', sortable: 'surveyPendingCount' },
  { label: 'Event mode' },
  { label: 'Status' },
  { label: 'Action' },
];

export const EventsParticipantsCol = [
  { label: 'S.No' },
  { label: 'Participant ID' },
  { label: 'Participant Type' },
  { label: 'Participant Name', sortable: 'participantName' },
  { label: 'Contact Number' },
  // { label: "Age" },
  // { label: "Gender" },
  // { label: "Collection Center" },
  // { label: "Location", sortable: "location" },
  // { label: "Participant Status" },
  { label: 'Consent of Survey' },
  { label: 'Demographic' },
  { label: 'Pre Survey' },
  { label: 'Post Survey' },
  { label: 'Post 3 Month Survey' },
  // { label: "Status" },
  { label: 'Actions' },
];
export const EventsInviteParticipantsCol = [
  { label: 'S.No' },
  { label: 'Participant Name', sortable: 'participantName' },
  { label: 'Contact Number' },
  { label: 'Post Survey' },
  { label: 'Post 3 month Survey' },
  { label: 'Demographic' },
  { label: 'Consent of Survey' },
  { label: 'Status' },
  { label: 'Actions' },
];
export const CCEventParticipantHeadCol = [
  { label: 'S.No' },
  { label: 'Farmer ID' },
  { label: 'Farmer Name', sortable: 'participantName' },
  { label: 'IC Number' },
  { label: 'Farm ID' },
  { label: 'Farm Area' },
  { label: 'Contact Number' },
  { label: 'Collection Center' },
  { label: 'Data Readiness' },
  { label: 'Status' },
];

export const LIEventParticipantHeadCol = [
  { label: 'S.No' },
  { label: 'Farmer ID' },
  { label: 'Farmer name', sortable: 'farmerName' },
  { label: 'Farm ID' },
  { label: 'Farm Area', sortable: 'location' },
  // { label: 'Farm Count' },
  { label: 'Contact' },
  { label: 'Collection Center' },
  { label: 'Organisation' },
  { label: 'Status' },
];
export const AttendanceCol = [
  { label: 'S.No' },
  { label: 'Farmer ID', sortable: 'id' },
  { label: 'Farmer name', sortable: 'farmerName' },
  { label: 'Farm ID' },
  { label: 'Farm area', sortable: 'farmArea' },
  { label: 'Contact' },
  { label: 'Organisation' },
  { label: 'Status' },
  { label: 'Action' },
];
export const AttendanceMark = [
  { label: 'S.No' },
  { label: 'Attendance date', sortable: 'date' },
  // { label: "Farmer ID" },
  { label: 'Participant ID' },
  // { label: "Farmer name", sortable: "farmerName" },
  { label: 'Participant name', sortable: 'participantName' },
  { label: 'Contact Number' },
  // { label: "Farm ID" },
  { label: 'Attendance time', sortable: 'attendencetime' },
  { label: 'Action' },
];

export const CCAttendanceMark = [
  { label: 'S.No' },
  { label: 'Attendance date', sortable: 'date' },
  { label: 'Farmer ID' },
  // { label: "Participant ID" },
  { label: 'Farmer name', sortable: 'farmerName' },
  { label: 'Contact Number' },
  // { label: "Participant name", sortable: "participantName" },
  { label: 'Farm ID' },
  { label: 'Attendance time', sortable: 'attendencetime' },
  { label: 'Action' },
];
export const LIAttendanceMark = [
  { label: 'S.No' },
  { label: 'Attendance date', sortable: 'date' },
  { label: 'Farmer ID' },
  // { label: "Participant ID" },
  { label: 'Farmer name', sortable: 'farmerName' },
  { label: 'Contact Number' },
  // { label: "Participant name", sortable: "participantName" },
  { label: 'Farm ID' },
  { label: 'Collection Center' },
  { label: 'RISS Group' },
  { label: 'Attendance time', sortable: 'attendencetime' },
  { label: 'Action' },
];

export const RequestsCol = [
  { label: 'Request ID' },
  { label: 'Request type' },
  { label: 'Request' },
  { label: 'Status', sortable: 'status' },
  { label: 'Action Taken By' },
  { label: 'Action Taken On' },
];

export const CollectionHeader = [
  { label: 'S.No' },
  { label: 'Farmer name & ID', sortable: 'farmerName' },
  { label: 'Organisation' },
  { label: 'IC number' },
  { label: 'Contact Number' },
  { label: 'Location', sortable: 'location' },
  { label: 'GPS' },
  { label: 'Data Readiness' },
  { label: 'Documentation Status' },
  { label: 'Action' },
  { label: 'Status' },
];

export const ResearchEventHeader = [
  { label: 'S.No' },
  { label: 'Farmer ID', sortable: 'farmerId' },
  { label: 'Farmer name', sortable: 'farmerName' },
  { label: 'IC number' },
  { label: 'Farm ID', sortable: 'farmId' },
  { label: 'Farm Area' },
  { label: 'Contact Number' },
  { label: 'Collection Center' },
];

export const ResearchInviteEventHeader = [
  { label: 'S.No' },
  { label: 'Farmer ID' },
  { label: 'Farmer name', sortable: 'farmerName' },
  { label: 'Farm ID' },
  { label: 'Farm Area', sortable: 'farmArea' },
  { label: 'Contact' },
  { label: 'Organisation' },
  { label: 'Status' },
];

export const ResearchAttendanceMark = [
  { label: 'S.No' },
  { label: 'Attendance date', sortable: 'date' },
  { label: 'Farmer ID' },
  { label: 'Farmer name', sortable: 'farmerName' },
  { label: 'Farm ID' },
  { label: 'Attendance time', sortable: 'attendencetime' },
  { label: 'Action' },
];

export const ResearchDataCollectionHeader = [
  { label: 'S.No' },
  { label: 'Event Name', sortable: 'eventName' },
  { label: 'Event ID', sortable: 'eventId' },
  { label: 'Event Date', sortable: 'eventDate' },
  { label: 'Event Location', sortable: 'location' },
  { label: 'Training Mode', sortable: 'trainingMode' },
  { label: 'No. of Participants', sortable: 'participantCount' },
  { label: 'View Details' },
];

export const ResearchCollectionHeader = [
  { label: 'S.No' },
  { label: 'Collection Centre Name', sortable: 'collectionCentre' },
  { label: 'No.of farmers', sortable: 'numberOfFarmers' },
  { label: 'Traceability status' },
  { label: 'View Details' },
];

export const AssessmentHeader = [
  { label: 'S.No' },
  { label: 'Group name', sortable: 'name' },
  { label: 'Group manager' },
  { label: 'Location' },
  { label: 'Farmers' },
  { label: 'Action' },
];
export const PillarHeadAssessmentHeader = [
  { label: 'No', key: 'no' },
  { label: 'Group Name', key: 'groupName', sortable: 'name' },
  { label: 'Milestone', key: 'milestone' },
  { label: 'Documents', key: 'documents' },
  { label: 'Group manager' },
  { label: 'Location' },
  { label: 'Farmers' },
  // { label: 'Action' },
];

export const RissGroupList = [
  { label: 'S.No' },
  { label: 'Farmer Name', sortable: 'farmerName' },
  { label: 'Farm Id' },
  { label: 'IC Number' },
  { label: 'Lacation' },
  { label: 'Action' },
];

export const AuditortHeader = [
  { label: 'S.No' },
  { label: 'Group name', sortable: 'farmerName' },
  { label: 'Organisation' },
  { label: 'Participants' },
  { label: 'Action' },
];

export const AuditReportHeader = [
  { label: 'S.No' },
  { label: 'Group name', sortable: 'farmerName' },
  { label: 'Organisation' },
  { label: 'Farmers' },
  { label: 'Action' },
];

export const CcFarmerJourney = [
  { label: 'S.No' },
  { label: 'Farmer Name & ID', sortable: 'farmerId' },
  { label: 'Event name', sortable: 'eventName' },
  { label: 'IC Number' },
  { label: 'Contact' },
  { label: 'Collection Center' },
  { label: 'Organisation' },
  { label: 'Milestone E' },
  { label: 'Milestone A' },
  { label: 'Milestone B' },
  { label: 'Data Completeness' },
  { label: 'Document Completeness' },
];

export const ParticipantJourney = [
  { label: 'S.No' },
  { label: 'Participant ID' },
  { label: 'Participant name', sortable: 'participantName' },
  // { label: "Gender" },
  { label: 'Participant Type' },
  { label: 'Contact' },
  { label: 'Organisation' },
  { label: 'Training status' },
  { label: 'Consent of survey' },
  { label: 'Demographic' },
  { label: 'Pre survey' },
  { label: 'Post survey' },
  { label: 'Post 3 month survey' },
  { label: 'E - learning status' },
  { label: 'Action' },
];
export const ApprovalCol = [
  { label: 'S.No' },
  { label: 'Event name' },
  { label: 'Event ID' },
  { label: 'Participant name', sortable: 'participantName' },
  { label: 'Participant IC number' },
  { label: 'Participant type' },
  { label: 'Contact' },
  { label: 'Collection center' },
  { label: 'Organisation' },
  { label: 'Status' },
  { label: 'Action Taken By' },
  { label: 'Action Taken On' },
  { label: 'Action' },
  // { label: "Approval" },
];

export const ScoreCardCol = [
  { label: 'S.No' },
  { label: 'Farmer name & ID', sortable: 'id' },
  // { label: "Farmer name & ID" },
  { label: 'IC number' },
  { label: 'Contact number' },
  { label: 'Document verification %' },
  { label: 'Score' },
];

export const VerificationCol = [
  { label: 'S.No' },
  { label: 'Farmer name & ID', sortable: 'farmerName' },
  { label: 'IC number' },
  { label: 'Contact number' },
  { label: 'Farm ID' },
  { label: 'Location', sortable: 'location' },
  { label: 'Area/Region' },
  { label: 'Address' },
  { label: 'Gps', sortable: 'gps' },
  { label: 'Desktop Verification' },
  { label: 'Field Verification' },
  { label: 'Status' },
  { label: 'Reason' },
  { label: 'Action Taken By' },
  { label: 'Action Taken On' },
  { label: 'Action' },
];

export const ReportAnalyticsCol_TV = [
  { label: 'S.No' },
  { label: 'Farmer ID' },
  { label: 'Farmer name', sortable: 'farmerName' },
  { label: 'Event Name' },
  { label: 'Contact ' },
  { label: 'IC number' },
  { label: 'Collection center' },
  { label: 'Status' },
];

export const Training_Report = [
  { label: 'S.No' },
  { label: 'Event ID' },
  { label: 'Event name' },
  { label: 'Event type' },
  { label: 'Date', sortable: 'date' },
  { label: 'Location', sortable: 'location' },
  { label: 'Participants count', sortable: 'numberOfParticipant' },
  { label: 'Training completion %', sortable: 'numberOfParticipant' },
  { label: 'Status' },
  { label: 'Action' },
];

export const Survey_Report = [
  { label: 'S.No' },
  { label: 'Participant name' },
  { label: 'Participant ID' },
  { label: 'Event ID' },
  { label: 'Event name' },
  { label: 'Event type' },
  { label: 'Date', sortable: 'date' },
  { label: 'Location', sortable: 'location' },
  { label: 'Consent' },
  { label: 'Demographic' },
  { label: 'Pre survey' },
  { label: 'Post survey' },
  { label: 'Post 3 month survey' },
  { label: 'Status' },
];

export const Upload_Report = [
  { label: 'S.No' },
  { label: 'Uploaded File Name' },
  { label: 'Uploaded Date' },
  { label: 'Uploaded By' },
  { label: 'Action' },
];

export const Participant_Report = [
  { label: 'S.No' },
  { label: 'Participant ID' },
  { label: 'Participant name' },
  { label: 'Event date' },
  { label: 'Contact number' },
  { label: 'Participant Age' },
  { label: 'IC number' },
  { label: 'Gender' },
  { label: 'Organisation' },
  { label: 'Participant type' },
  { label: 'Farm Location' },
  { label: 'Participant status' },
  { label: 'Status' },
];

export const ReportAnalyticsCol_Diffusion = [
  { label: 'S.No' },
  { label: 'Event ID' },
  { label: 'Event name' },
  { label: 'Event type' },
  { label: 'Date', sortable: 'date' },
  { label: 'Location', sortable: 'location' },
  { label: 'Participants registered', sortable: 'ParticipantRegistered' },
  { label: 'Participants Attended', sortable: 'ParticipantAttended' },
  { label: 'Attendance %', sortable: 'attendance' },
  { label: 'Status' },
];

export const FarmReportCol_TV = [
  { label: 'S.No' },
  { label: 'Farmer', sortable: 'farmerName' },
  { label: 'Farm ID' },
  { label: 'Collection Center' },
  { label: 'Organisation' },
  { label: 'Type of Ownership' },
  { label: 'Location' },
  // { label: "Farm area(Hect)" },
  { label: 'Registered Area(Hectares)' },
  { label: 'MPOB Status' },
  { label: 'MSPO Status' },
  { label: 'RSPO Status' },
  // { label: "Score", sortable: 'score' },
  { label: 'Pillar Head Approval' },
  // { label: 'Action' },
];
export const TTPDataReportReportCol_TV = [
  { label: 'S.No' },
  { label: 'Farmer', sortable: 'farmerName' },
  { label: 'Farm ID' },
  { label: 'Collection Center' },
  { label: 'Organisation' },
  { label: 'Location' },
  { label: 'Farm Count', sortable: 'farmCount' },
  { label: 'TTP Data Completeness' },
  // { label: 'Action' },
];

export const DocumentDataReportCol_TV = [
  { label: 'S.No' },
  { label: 'Farmer', sortable: 'farmerName' },
  { label: 'Farm ID' },
  { label: 'Collection Center' },
  { label: 'Organisation' },
  { label: 'Location' },
  { label: 'Farm Count', sortable: 'farmCount' },
  { label: 'Documentation Status' },
  // { label: 'Action' },
];
export const ScoreCardDataReportCol_TV = [
  { label: 'S.No' },
  { label: 'Farmer', sortable: 'farmerName' },
  { label: 'Farm ID' },
  { label: 'Collection Center' },
  { label: 'Organisation' },
  { label: 'Location' },
  { label: 'Score', sortable: 'score' },
  // { label: 'Action' },
];
export const ApprovalDataReportCol_TV = [
  { label: 'S.No' },
  { label: 'Farmer Id', sortable: 'farmerId' },
  { label: 'Farmer Name', sortable: 'farmerName' },
  // { label: "Score" },
  { label: 'Approval' },
  { label: 'Farm Count', sortable: 'farmCount' },
  { label: 'Data Verification' },
  { label: 'Reason' },
  { label: 'Action Taken By ' },
  { label: 'Action Taken On' },
  // { label: 'Action' },
];

//CC
export const FarmerDataReportCol_CC = [
  { label: 'S.No' },
  { label: 'Event Name' },
  { label: 'Farmer ID' },
  { label: 'Farmer Name', sortable: 'Farmer name' },
  { label: 'Farm ID' },
  { label: 'Farm Area', sortable: 'Farm Area' },
  { label: 'Contact' },
  { label: 'Organisation' },
  { label: 'RISS Status', sortable: 'RISS Status' },
  { label: 'Status' },
];

export const FarmDataReportCol_CC = [
  { label: 'S.No' },
  { label: 'Farmer Name', sortable: 'Farmer name' },
  { label: 'Farm ID' },
  { label: 'Collection Center' },
  { label: 'Location' },
  { label: 'Soil Type' },
  { label: 'Total Planted Area (Ha)' },
  { label: 'Land Title Area (Ha)' },
  { label: 'Registered Area Under RISS (Ha)' },
  { label: 'ISH Status' },
  { label: 'Ownership Type' },
];

export const FFBDataReportCol_CC = [
  { label: 'S.No' },
  { label: 'Farm ID' },
  { label: 'Collection Center' },
  { label: 'Data Collection Date' },
  { label: 'Land Owner Name' },
  { label: 'Harvest Date' },
  { label: 'Data Input' },
];

export const FertilizerDataReportCol_CC = [
  { label: 'S.No' },
  { label: 'Farm ID' },
  { label: 'Data Collection Date' },
  { label: 'Land Owner Name' },
  { label: 'LOT No' },
  { label: 'Fertilizer Name' },
  { label: 'Total Bags' },
  { label: 'Unit' },
  { label: 'Price Per Bag/Barrel (RM)' },
];

export const ChemicalDataReportCol_CC = [
  { label: 'S.No' },
  { label: 'Farm ID' },
  { label: 'Data Collection Date' },
  { label: 'Land Owner Name' },
  { label: 'LOT No' },
  { label: 'Chemical Name' },
  { label: 'Weight Per Bag/Barrel' },
  { label: 'Unit' },
  { label: 'Price Per Bag/Barrel (RM)' },
];

export const ExpensesDataReportCol_CC = [
  { label: 'S.No' },
  { label: 'Farm ID' },
  { label: 'Data Collection Date' },
  { label: 'Date Receipt' },
  { label: 'Land Owner Name' },
  { label: 'LOT No' },
  { label: 'Category' },
  { label: 'Unit' },
  { label: 'Wages RM' },
  { label: 'Price Per Bag/Barrel (RM)' },
];

export const WorkerDataReportCol_CC = [
  { label: 'S.No' },
  { label: 'Farm ID' },
  { label: 'Collection Center' },
  { label: 'Land Owner Name' },
  { label: 'Worker Name' },
  { label: 'Worker Type' },
  { label: 'ID No' },
  { label: 'Permit No' },
  { label: 'Year Start Working' },
];

export const TrainingDataReportCol_CC = [
  { label: 'S.No' },
  { label: 'Event ID' },
  { label: 'Event Name' },
  { label: 'Event Type' },
  { label: 'Date', sortable: 'Date' },
  { label: 'Location', sortable: 'Location' },
  { label: 'Farmers Count', sortable: 'Farmers count' },
  { label: 'Status' },
];

export const PremiumCalculationDataReportCol_CC = [
  { label: 'S.No' },
  { label: 'Farm ID' },
  { label: 'Land Owner Name' },
  { label: 'FFB Year' },
  { label: 'ISH Category' },
  { label: 'LOT No' },
  { label: 'Registered Area Under RISS (Ha)' },
  { label: 'Total Planted Area (Ha)' },
  { label: 'Actual FFB (MT)' },
  // { label: 'Actual Tonnage' },
  { label: 'Forecast (MT)' },
  // { label: 'Forecast Tonnage' },
  { label: 'Yield' },
  { label: 'RISS Group' },
];

export const UploadedReportDataReportCol_CC = [
  { label: 'S.No' },
  { label: 'Uploaded File Name' },
  { label: 'Uploaded Date', sortable: 'Uploaded Date' },
  { label: 'Uploaded By', sortable: 'Uploaded By' },
  { label: 'Action' },
];

export const FarmerReport_Diffusion = [
  { label: 'S.No' },
  { label: 'Event Name' },
  { label: 'Farmer ID' },
  { label: 'Farmer Name', sortable: 'farmerName' },
  { label: 'Farm ID' },
  { label: 'Farm Area', sortable: 'farmArea' },
  { label: 'Contact' },
  { label: 'Organisation' },
  { label: 'Status' },
  { label: 'Action' },
];

export const OnboardingCol = [
  { label: 'Organisation Name', sortable: 'organisationName' },
  { label: 'Organisation ID', sortable: 'id' },
  { label: 'Location', sortable: 'location' },
  { label: 'Collection Centres' },
  { label: 'Farmers' },
  { label: 'Org POC' },
  { label: 'Action' },
];

export const CollectionCenterCol = [
  { label: 'Center Name', sortable: 'centerName' },
  { label: 'Center ID', sortable: 'id' },
  { label: 'Location', sortable: 'location' },
  { label: 'No. Of Farmers' },
  { label: 'Contact' },
  { label: 'Status' },
  { label: 'Action' },
];
export const FarmerEventsCol = [
  { label: 'S.No' },
  { label: 'Event ID' },
  { label: 'Event Name' },
  { label: 'Date' },
  { label: 'Location', sortable: 'location' },
  { label: 'Participant Count' },
  { label: 'Status' },
  { label: 'Action' },
];
export const FarmerEventsColForTV = [
  { label: 'S.No' },
  { label: 'Farmer name & ID', sortable: 'farmer' },
  { label: 'Event name', sortable: 'eventName' },
  { label: 'IC Number' },
  { label: 'Contact' },
  { label: 'Collection Center', sortable: 'collectionCenter' },
  { label: 'Organisation', sortable: 'organisation' },
  { label: 'Awaiting To Trace' },
  { label: 'Trace To Plantation' },
  { label: 'Trace To Verify' },
  { label: 'Pillar Head Approval' },
  { label: 'Action Taken By', sortable: 'actionTakenBy' },
  { label: 'Action Taken On', sortable: 'actionTakenOn' },
];

export const FarmerEventsColForLI = [
  { label: 'SI No', key: 'sNo' },
  { label: 'Farm ID', key: 'farmGenId' },
  { label: 'Farmer Name', key: 'farmer' },
  { label: 'IC Number', key: 'ic' },
  { label: 'Contact', key: 'contact' },
  { label: 'View Program', key: 'programs' },
  { label: 'RISS Group', key: 'rissGroup' },
  { label: 'Collection Centre', key: 'collectionCentreText' },
  { label: 'Continuous Improvement Cycle', key: 'CICycle' },
  { label: 'View Event Details', key: 'eventDetails' },
  { label: 'Data' },
];

export const FarmerEventsColForCC = [
  { label: 'S.No' },
  { label: 'Farmer name & ID', sortable: 'farmer' },
  { label: 'Event name' },
  { label: 'IC Number' },
  { label: 'Contact' },
  { label: 'Collection Center' },
  { label: 'Organisation' },
  { label: 'Milestone E' },
  { label: 'Milestone A' },
  { label: 'Milestone B' },
  { label: 'Data Completeness' },
  { label: 'Document Completeness' },
];

export const FarmerViewColForDifusion = [
  { label: 'S. No' },
  { label: 'Farmer ID' },
  { label: 'Event ID' },
  { label: 'Farmer Name', sortable: 'farmerName' },
  // { label: 'Farm ID' },
  { label: 'Farm Area', sortable: 'farmArea' },
  { label: 'Contact' },
  { label: 'Organisation' },
  { label: 'Training status' },
  { label: 'Demographic' },
  { label: 'Pre -Survey' },
  { label: 'Post Survey' },
  { label: 'Post 3 month Survey' },
  { label: 'E - learning status' },
  // { label: 'Action' },
];

export const ResearchEventsCol = [
  { label: 'S.No' },
  { label: 'Event ID' },
  { label: 'Event Name' },
  { label: 'Date', sortable: 'eventDate' },
  { label: 'Location' },
  { label: 'Event Mode', sortable: 'eventMode' },
  // { label: 'Pillar', sortable: 'pillar' },
  { label: 'Training Mode', sortable: 'trainingMode' },
  { label: 'Status' },
  { label: 'Action' },
];

export const FarmersCol = [
  { label: 'Farmer Name', sortable: 'centerName' },
  { label: 'Farmer ID', sortable: 'id' },
  { label: 'Location', sortable: 'location' },
  { label: 'No. Of Farms' },
  { label: 'Tot. Farm Area' },
  { label: 'Contact' },
  { label: 'Status' },
  { label: 'Action' },
];
export const CcAuditReviewCol = [
  { label: 'Farmer', sortable: 'farmerName' },
  { label: 'Data Completeness' },
  { label: 'Documentation Status' },
  { label: 'Farmer Journey' },
  { label: 'Action Taken By' },
  { label: 'Action Taken On' },
  { label: 'Reason' },
  { label: 'Status' },
  { label: 'Action' },
];
export const CcAuditCompletionCol = [
  { label: 'S.No' },
  { label: 'Group Name' },
  // { label: 'Group Manager' },
  // { label: 'Location' },
  { label: 'Participants' },
  { label: 'Action Taken By' },
  { label: 'Action Taken On' },
  { label: 'Reason' },
  { label: 'Reports' },
  { label: 'Status' },
  { label: 'Action' },
];
export const CcTrainingCompletion = [
  { label: 'S.No' },
  { label: 'Farmer Name', sortable: 'farmerName' },
  { label: 'Farmer Id', sortable: 'farmerId' },
  { label: 'Milestone', sortable: 'milestone' },
  { label: 'Event', sortable: 'event' },
  // { label: 'Modules' },
  { label: 'Action Taken By', sortable: 'actionTakenBy' },
  { label: 'Action Taken On', sortable: 'actionTakenOn' },
  { label: 'Reason' },
  { label: 'Status' },
  { label: 'Action' },
];
export const CcRegistration = [
  { label: 'S.No' },
  { label: 'Farmer Name', sortable: 'farmerName' },
  { label: 'Farmer Id', sortable: 'farmerId' },
  { label: 'Milestone', sortable: 'milestone' },
  { label: 'Event', sortable: 'event' },
  { label: 'Contact' },
  { label: 'Action Taken By', sortable: 'actionTakenBy' },
  { label: 'Action Taken On', sortable: 'actionTakenOn' },
  { label: 'Reason' },
  { label: 'Status' },
  { label: 'Action' },
];

export const FormerViewJourney = [
  { label: 'Farmer', sortable: true },
  { label: 'Event name' },
  { label: 'IC Number' },
  { label: 'Contact' },
  { label: 'Collection Center' },
  { label: 'Organisation' },
  { label: 'Milestone E' },
  { label: 'Milestone A' },
  { label: 'Milestone B' },
  { label: ' Data Completeness' },
  { label: ' Pillar Head Approval' },
  { label: ' Action Taken By ' },
  { label: ' Action Taken On' },
];

export const DiffFormerViewJourney = [
  { label: 'S.No' },
  { label: 'Farmer ID', sortable: true },
  { label: 'Farmer name' },
  { label: 'IC Number' },
  { label: 'Contact' },
  // { label: "Collection Center", },
  { label: 'Organisation' },
  { label: 'Training Status' },
  { label: 'Demographic' },
  { label: 'Pre Survey' },
  { label: 'Post Survey' },
  { label: 'Post 3 Month Survey' },
  { label: 'Constent Survey' },
  { label: 'E - learning Status' },
  { label: ' Action' },
];

export const FarmerSuperAdminCol = [
  { label: 'S.No' },
  { label: 'Farmer', sortable: 'farmer' },
  { label: 'Collection Center' },
  { label: 'Awaiting To Trace' },
  { label: 'Trace To Plantation' },
  { label: 'Trace To Verify' },
  { label: 'Pilar Head Approval' },
  { label: 'Action Taken By' },
  { label: 'Action Taken On' },
];

export const ApprovalSuperAdminCol = [
  { label: 'Farmer', sortable: 'farmerName' },
  // { label: "Score", sortable: "score" },
  { label: 'Approval' },
  { label: 'Farm Count', sortable: 'farmCount' },
  { label: 'TTP Data Completeness' },
  { label: 'Documentation Status' },
  { label: 'Reason' },
  { label: 'Action Taken By' },
  { label: 'Action Taken On' },
  { label: 'Action' },
];

export const UserManagementCol = [
  { label: 'S.No' },
  { label: 'Employee ID' },
  { label: 'Name' },
  { label: 'Contact' },
  { label: 'Email' },
  { label: 'Role' },
  { label: 'Pillar' },
  { label: 'Status' },
  { label: 'Action' },
];

export const CustManagementCol = [
  { label: 'S.No' },
  { label: 'Name' },
  { label: 'Contact' },
  { label: 'Email' },
  { label: 'Role' },
  // { label: 'Status' },
  { label: 'Action' },
];

export const UserRoleManagementCol = [
  { label: 'S.No' },
  { label: 'Role Name' },
  { label: 'Pillar Name' },
  // { label: 'Categories' },
  { label: 'Action' },
];

//CC

export const EligibleCol = [
  { label: 'S.NO' },
  { label: 'Farmer name & ID', sortable: 'farmer' },
  { label: 'IC Number' },
  { label: 'Contact Number' },
  { label: 'Farm ID' },
  { label: 'Location', sortable: 'location' },
  { label: 'GPS', sortable: 'gps' },
  { label: 'Organisation' },
  { label: 'Status' },
  { label: 'Action' },
];

export const EventTabs = [
  { label: 'All Events', value: ALL_EVENTS },
  { label: 'Ongoing Events', value: ONGOING_EVENTS },
  { label: 'Upcoming Events', value: UPCOMING_EVENTS },
  { label: 'Completed Events', value: COMPLETED_EVENTS },
  { label: 'Cancelled Events', value: CANCELLED_EVENTS },
  { label: 'Postponed Events', value: POSTPONED_EVENTS },
];

export const ResearchEventTabs = [
  { label: 'All Events', value: ALL_EVENTS },
  { label: 'Ongoing Events', value: ONGOING_EVENTS },
  { label: 'Upcoming Events', value: UPCOMING_EVENTS },
  { label: 'Completed Events', value: COMPLETED_EVENTS },
  { label: 'Cancelled Events', value: CANCELLED_EVENTS },
  { label: 'Postponed Events', value: POSTPONED_EVENTS },
];
export const ParticipantTabs = [
  { label: 'Registered', value: REGISTERED },
  { label: 'Invite', value: INVITE_SENT },
];

export const SurveyTabs = [
  { label: 'All Events', value: ALL_EVENTS },
  { label: 'Completed Events', value: COMPLETED_EVENTS },
  { label: 'Ongoing Events', value: ONGOING_EVENTS },
  { label: 'Upcoming Events', value: UPCOMING_EVENTS },
];

export const TraceTabs = [
  { label: 'Awaiting to Trace', value: AWAITING_TO_TRACE },
  { label: 'Trace to Plantation', value: TRACE_TO_PLANTATION },
  { label: 'Trace to Verify', value: TRACE_TO_VERIFY },
];

export const TraceFormTabs = [
  { label: 'Farmer Details', value: FARMER_DETAILS },
  { label: 'Farm Details', value: FARM_DETAILS },
  { label: 'Labour Details', value: WORKER_DETAILS },
  { label: 'FFB Details', value: FFB_DETAILS },
];

export const ApprovalTabs = [
  { label: 'Registration', value: registered },
  { label: 'Training Completion', value: training_approved }, // BE confrimed this key should be like this for completion
];

export const TrainingTabs = [
  { label: 'Training Modules', value: TRAINING_LESSON },
  // { label: "Comments & Feedback", value: COMMENT_FEEDBACK },
];

//cc

export const MemberPortalTabs = [
  { label: 'Eligible', value: ELIGIBLE },
  { label: 'Partially eligible', value: PARTIALLYELIGIBLE },
];

export const PotentialISHTabs = [
  { label: 'S.No', value: 'sNo' },
  { label: 'Farmer name & ID', value: 'farmer', sortable: 'farmerName' },
  { label: 'Organisation', value: 'organisation' },
  { label: 'IC Number', value: 'icNumber' },
  { label: 'GPS', value: 'GPS' },
  { label: 'Contact Number', value: 'contactNumber' },
  { label: 'MPOB', value: 'mpob' },
  { label: 'TTP Data Completeness', value: 'ttpDataCompleteness' },
  { label: 'Documents Completeness', value: 'documentsCompleteness' },
  { label: 'Status', value: 'status' },
  { label: 'Remarks', value: 'remarks' },
  { label: 'Documents', value: 'documents' },
];

export const ReportTabsTV = [
  { label: 'Farmer Report', value: FARMER_REPORT },
  { label: 'TTP data Report', value: TTP_DATA_REPORT },
  { label: 'Documents', value: DOCUMENTS_REPORT },
  { label: 'Approval', value: APPROVAL_REPORT },
];

export const verificationTabs = [{ label: 'Verify farmer', value: VERIFY_FARMER }];
export const CcAprovalsTabs = [
  { label: 'Registration', value: REGISTRATION },
  { label: 'Training Completion', value: TRAINING_COMPLETION },
  { label: 'Audit Review', value: AUDIT_REVIEW },
  { label: 'Audit Completion ', value: AUDIT_COMPLETION },
];
export const ReportTabsTVList = [
  { label: 'Farm Report', value: FARM_REPORT },
  { label: 'TTP Data Report', value: TTP_DATA_REPORT },
  { label: 'Documents', value: DOCUMENTS_REPORT },
  // { label: "Scorecard", value: REPORT_SCORECARD },
  { label: 'Approval', value: APPROVAL_REPORT },
];

export const ReportTabsCcList = [
  { label: 'Farmers', value: Farmer_CcReport },
  { label: 'Farm', value: Farm_CcReport },
  { label: 'FFB', value: FFB_CcReport },
  { label: 'Fertilizer', value: Fertilizer_CcReport },
  { label: 'Chemical', value: Chemical_CcReport },
  { label: 'Expenses', value: Expenses_CcReport },
  { label: 'Worker', value: Worker_CcReport },
  { label: 'Training', value: Training_CcReport },
  { label: 'Premium Calculation', value: Premium_Calculation_CcReport },
  { label: 'Uploaded Report', value: Uploaded_Report_CcReport },
];

export const ReportTabsDiffusion = [
  { label: 'Event Report', value: EVENT_REPORT },
  { label: 'Participant Report', value: PARTICIPANT_REPORT },
  { label: 'Survey Responses', value: SURVEY_REPORT },
  { label: 'Upload Reports', value: UPLOADED_REPORT },
];

export const UserManagementTabs = [
  { label: 'Roles Management', value: 'userRoles' },
  { label: 'Employee Management', value: 'users' },
  { label: 'Users Management', value: 'farmer' },
];
export const DataCollectionAddData = [
  { label: 'Documents', value: ADD_DOCUMENTS },
  { label: 'Data', value: ADD_DATA },
];

export const DataCollectionAddDataForResearch = [{ label: 'Data', value: ADD_DATA }];

export const OnboardingTabs = [
  { label: 'Organisations', value: ORGANISATIONS },
  { label: 'Collection_Centers', value: COLLECTION_CENTRES },
  { label: 'Farmers', value: FARMERS },
  { label: 'Plantation', value: PLANTATION },
];

export const StatusFilter = [
  {
    title: 'Status',
    type: 'status',
    list: [
      { label: 'Ongoing', value: 'ongoing', selected: false },
      { label: 'Upcoming', value: 'upcoming', selected: false },
      { label: 'Completed', value: 'completed', selected: false },
      { label: 'Cancelled', value: 'cancelled', selected: false },
    ],
  },
];

export const VerificationStatusFilter = [
  {
    title: 'Status',
    type: 'status',
    list: [
      { label: 'Verified', value: 'verified', selected: false },
      { label: 'Not Verified', value: 'not_verified', selected: false },
      { label: 'Rejected', value: 'rejected', selected: false },
    ],
  },
];

export const ApprovalStatusFilter = [
  {
    title: 'Status',
    type: 'status',
    list: [
      { label: 'Training Completed', value: 'completed', selected: false },
      { label: 'Approved', value: 'approved', selected: false },
      { label: 'Rejected', value: 'rejected', selected: false },
      { label: 'Pending', value: 'pending', selected: false },
    ],
  },
];

export const ApprovalStatusFilterForTV = [
  {
    title: 'Status',
    type: 'status',
    list: [
      { label: 'Approved', value: 'approved', selected: false },
      { label: 'Rejected', value: 'rejected', selected: false },
      { label: 'Pending', value: 'pending', selected: false },
    ],
  },
];

export const ModuleStatusFilter = [
  {
    title: 'Module',
    type: 'module',
  },
  {
    title: 'Status',
    type: 'event_status',
  },
  {
    title: 'Event Mode',
    type: 'event_mode',
  },
];
export const ModuleCCStatusFilter = [
  {
    title: 'Event Type',
    type: 'EventType',
  },
  {
    title: 'Module',
    type: 'module',
  },
  {
    title: 'Status',
    type: 'event_status',
  },
  {
    title: 'Event Mode',
    type: 'event_mode',
  },
];

export const TraceFilter = [
  {
    title: 'Role',
    type: 'types_of_participant',
  },
  {
    title: 'Status',
    type: 'awaiting_to_trace_status',
  },
  {
    title: 'Collection Center',
    type: 'collection_center',
  },
];

export const TraceToVerifyFilter = [
  {
    title: 'Collection Center',
    type: 'collection_center',
  },
];

export const Premium_Calculation_CcReport_Filter = [
  {
    title: 'ISH Category',
    type: 'ISH_Category',
  },
];

export const Farmer_CcReport_Filter = [
  {
    title: 'Organisation',
    type: 'organisation',
  },
];

export const Farm_CcReport_Filter = [
  {
    title: 'ISH Status',
    type: 'ISH_Status',
  },
  {
    title: 'Ownership Type',
    type: 'type_of_ownership',
  },
  {
    title: 'Collection Center',
    type: 'collection_center',
  },
];

export const FFB_CcReport_Filter = [
  {
    title: 'Collection Center',
    type: 'collection_center',
  },
];

export const Expenses_CcReport_Filter = [
  {
    title: 'Category',
    type: 'Expense_Category',
  },
];

export const Worker_CcReport_Filter = [
  {
    title: 'Collection Center',
    type: 'collection_center',
  },
];

export const Training_CcReport_Filter = [
  {
    title: 'Event Type',
    type: 'EventType',
  },
];

export const TracePlantationFilter = [
  {
    title: 'MPOB Status',
    type: 'mpob_status',
    list: [
      { label: 'Yes', value: 'yes', selected: false },
      { label: 'No', value: 'no', selected: false },
    ],
  },
  {
    title: 'MSPO Status',
    type: 'mspo_status',
    list: [
      { label: 'Yes', value: 'yes', selected: false },
      { label: 'No', value: 'no', selected: false },
    ],
  },
  {
    title: 'Collection Center',
    type: 'collection_center',
  },
];

export const ModuleLessonFilter = [
  {
    title: 'Lesson Type',
    type: 'lesson_type',
    list: [
      { label: 'PDF', value: 'books', selected: false },
      { label: 'Poster', value: 'poster', selected: false },
      { label: 'Video', value: 'video', selected: false },
      // { label: 'Slide Presentation', value: 'Slide_presentation', selected: false },
      // { label: 'Other', value: 'other', selected: false },
    ],
  },
];

export const CCModuleLessonFilter = [
  {
    title: 'Lesson Type',
    type: 'lesson_type',
    list: [
      { label: 'PDF', value: 'books', selected: false },
      { label: 'Poster', value: 'poster', selected: false },
      { label: 'Video', value: 'video', selected: false },
      // { label: 'Text', value: 'text', selected: false },
      // { label: 'Slide Presentation', value: 'Slide_presentation', selected: false },
    ],
  },
];

export const ModuleListFilter = [
  {
    title: 'Module',
    type: 'module',
  },
  {
    title: 'Event Mode',
    type: 'event_mode',
  },
];

export const FarmerJourneyListFilter = [
  {
    title: 'Event Status',
    type: 'event_status',
  },
];

export const EventListCCStatusFilter = [
  {
    title: 'Module',
    type: 'module',
  },
  {
    title: 'Status',
    type: 'event_status',
  },
  {
    title: 'Event Mode',
    type: 'event_mode',
  },
  {
    title: 'Event Type',
    type: 'EventType',
  },
];
export const EventListCCStatusFilterTab = [
  {
    title: 'Module',
    type: 'module',
  },

  {
    title: 'Event Mode',
    type: 'event_mode',
  },
  {
    title: 'Event Type',
    type: 'EventType',
  },
];

export const EventListResearchStatusFilterTab = [
  {
    title: 'Event Mode',
    type: 'event_mode',
  },
  {
    title: 'Event Type',
    type: 'EventType',
  },
];
export const EventListFilter = [
  {
    title: 'Module',
    type: 'module',
  },
  {
    title: 'Status',
    type: 'event_status',
  },
  {
    title: 'Event Mode',
    type: 'event_mode',
  },
];

export const FarmerListFilter = [
  {
    title: 'Status',
    type: 'pillar_head_approval',
  },
];

export const CCFarmerListFilter = [
  {
    title: 'Status',
    type: 'event_status',
  },
];

export const CCApprovalRegistrationFilter = [
  {
    title: 'Status',
    type: 'CC_Participant_Status_Filter',
  },
];

export const CCApprovalRegisTrainingFilter = [
  {
    title: 'Status',
    type: 'approvalStatusFilter',
  },
];

export const CCApprovalTrainingCompletionFilter = [
  {
    title: 'Status',
    type: 'CC_Training_Status_Filter',
  },
];

export const EventParticipantsFilter = [
  // If needed in future uncomment this
  // {
  //   title: 'Participants Status',
  //   type: 'participant_status',
  // },
  {
    title: 'Collection Center',
    type: 'collection_center',
  },
];
export const EventCCParticipantsFilter = [
  {
    title: 'Status',
    type: 'ccPhasesOfParticipant',
  },
  {
    title: 'Collection Center',
    type: 'collection_center',
  },
];

export const SurveyStatusFilter = [
  {
    title: 'Survey Status',
    type: 'survey',
  },
];

export const TrainingStatusFilter = [
  {
    title: 'Module',
    type: 'module',
  },
];

export const FarmerFilterOption = [
  {
    title: 'Gender',
    type: 'gender',
  },
  {
    title: 'Type of Participant',
    type: 'types_of_participant',
  },
];

export const CCFarmerFilterOption = [
  {
    title: 'Status',
    type: 'pillar_head_approval',
  },
];

export const ResearchFarmerFilterOption = [
  {
    title: 'Status',
    type: 'invitation_status',
  },
];

export const ResearchFarmerViewFilterOption = [
  // {
  //   title: 'Training Status',
  //   type: 'module',
  // },
  {
    title: 'Training Status',
    type: 'phases_of_participants',
  },
];

export const ApprovalFilterOption = [
  {
    title: 'Status',
    type: 'participant_approval',
  },
];

export const ApprovalFilterOptionTraining = [
  {
    title: 'Status',
    type: 'training_status',
  },
];
export const ApprovalTvFilterOption = [
  {
    title: 'Status',
    type: 'approval_status',
  },
];

export const UserManagementStatusFilter = [
  {
    title: 'IISH Status',
    type: 'ccIShStatus',
  },
];

export const CCFarmerFilter = [
  {
    title: 'Milestone',
    type: 'milestone',
    list: [
      { label: 'Milestone E', value: 'E', selected: false },
      { label: 'Milestone A', value: 'A', selected: false },
      { label: 'Milestone B', value: 'B', selected: false },
    ],
  },
  {
    title: 'Collection Center',
    type: 'collection_center',
  },
];

export const SurveyModuleStatusFilter = [
  {
    title: 'Survey Status',
    type: 'survey',
    list: [
      {
        label: 'Demographic surveyy',
        value: 'demographic_survey',
        selected: false,
      },
      { label: 'Pre - survey', value: 'pre_survey', selected: false },
      { label: 'Post - survey', value: 'post_survey', selected: false },
      {
        label: 'Post 3 month survey',
        value: 'post_3_month_survey',
        selected: false,
      },
      { label: 'Consent of Survey', value: 'consent_survey', selected: false },
    ],
  },
  {
    title: 'Training Status',
    type: 'module',
    list: [
      { label: 'Module 1', value: 'module1', selected: false },
      { label: 'Module 2', value: 'module2', selected: false },
      { label: 'Module 3', value: 'module3', selected: false },
      { label: 'Module 4', value: 'module4', selected: false },
    ],
  },
  {
    title: 'Status',
    type: 'status',
    list: [
      { label: 'Registered', value: 'registered', selected: false },
      { label: 'Ongoing', value: 'ongoing', selected: false },
      { label: 'Upcoming', value: 'upcoming', selected: false },
      { label: 'Completed', value: 'completed', selected: false },
      { label: 'Cancelled', value: 'cancelled', selected: false },
    ],
  },
];

//    TRACE HEADERS

export const dataCCFilter = [
  {
    title: 'RISS Group',
    type: 'Riss_Group',
  },
  {
    title: 'Collection Center',
    type: 'collectionCenter',
  },
];

export const TvReportFilter = [
  {
    title: 'RSPO Status',
    type: 'rspo_status',
  },
  {
    title: 'MSPO Status',
    type: 'MSPO_Status',
  },
  {
    title: 'MPOB Status',
    type: 'MPOB_Status',
  },
];

export const AwaitingTraceCol = [
  { label: 'S.No' },
  { label: 'Farmer Name', sortable: 'farmerName' },
  { label: 'Farmer ID', sortable: 'farmerGenID' },
  { label: 'NRIC Number' },
  { label: 'Contact Number' },
  { label: 'Current Role' },
  { label: 'Collection Center' },
  // { label: 'MPOB' },
  // { label: 'MSPO' },
  { label: 'Status' },
  { label: 'Action' },
];
export const PlantationTraceCol = [
  { label: 'S.No', width: '60px' },
  { label: 'Farmer Name', width: '150px' },
  { label: 'Farmer ID', width: '120px' },
  { label: 'Collection Center', width: '150px' },
  // { label: 'Location' },
  // { label: 'Contact Number' },
  // { label: 'NRIC Number' },
  { label: 'MPOB', width: '100px' },
  { label: 'MSPO', width: '100px' },
  { label: 'Status of Traceability', width: '180px' },
  { label: 'Sustainability Compliance for Smallholders', width: '320px' },
  // { label: 'Current Role' },
  { label: 'Data of TTP', width: '150px' },
  { label: 'Documents', width: '120px' },
];

export const FIELD_SUB_TYPE_OPTIONS = {
  other: [
    { label: 'Text Input', value: 'text_input' },
    { label: 'Number Input', value: 'number_input' },
    { label: 'Email Input', value: 'email_input' },
    { label: 'Mobile Number Input', value: 'mobile_number_input' },
    { label: 'Date Input', value: 'date_input' },
    { label: 'Time Input', value: 'Time_input' },
    { label: 'URL Input', value: 'url_input' },
    { label: 'TextArea Input', value: 'textarea_input' },
  ],
  drop_down: [
    { label: 'Single Select', value: 'single_select' },
    { label: 'Multi Select', value: 'multi_select' },
  ],
  radio_button: [
    { label: 'Horizontal', value: 'horizontal' },
    { label: 'Vertical', value: 'vertical' },
  ],
  check_box: [
    { label: 'Single CheckBox', value: 'single_checkbox' },
    { label: 'Multi CheckBox', value: 'multi_checkbox' },
  ],
};

export const diffusionMicroApps = [
  { id: '1', label: 'Dashboard', value: 'dashboard', icon: 'dashboard' },
  { id: '2', label: 'Events', value: 'event', icon: 'event' },
  { id: '3', label: 'Survey', value: 'survey', icon: 'survey' },
  { id: '4', label: 'Training', value: 'training', icon: 'training' },
  { id: '5', label: 'Farmer Journey', value: 'farmer', icon: 'farmer' },
  { id: '6', label: 'Approval', value: 'approval', icon: 'approval' },
  {
    id: '7',
    label: 'Report and Analytics',
    value: 'reportAnalyse',
    icon: 'reportAnalyse',
  },
  { id: '8', label: 'Settings', value: 'setting/profile', icon: 'setting' },
];

export const tvMicroApps = [
  { id: '1', label: 'Dashboard', value: 'dashboard', icon: 'dashboard' },
  { id: '2', label: 'Trace', value: 'trace', icon: 'event' },
  // { id: '3', label: "Compliance", value: "compliance", icon: "compliance" },
  // { id: '4', label: "Score Card", value: "scoreCard", icon: "scoreCard" },
  { id: '5', label: 'Approval', value: 'approval', icon: 'approval' },
  { id: '6', label: 'Farmer Journey', value: 'farmer', icon: 'farmer' },
  {
    id: '7',
    label: 'Report and Analytics',
    value: 'reportAnalyse',
    icon: 'reportAnalyse',
  },
  { id: '8', label: 'Settings', value: 'setting/profile', icon: 'setting' },
];

export const CCMicroApps = [
  { id: '1', label: 'Dashboard', value: 'dashboard', icon: 'dashboard' },
  { id: '2', label: 'Events', value: 'event', icon: 'event' },
  { id: '3', label: 'Potential ISH', value: 'potentialISH', icon: 'survey' },
  {
    id: '4',
    label: 'Verification',
    value: 'verification',
    icon: 'verification',
  },
  {
    id: '5',
    label: 'Data Collection',
    value: 'datacollection',
    icon: 'reportAdmin',
  },
  { id: '6', label: 'Assessment', value: 'assessment', icon: 'assessment' },
  { id: '6a', label: 'LI Assessment Report', value: 'li_report', icon: 'assessment' },
  { id: '7', label: 'Training', value: 'training', icon: 'training' },
  { id: '8', label: 'Audit Report', value: 'auditreport', icon: 'assessment' },
  { id: '9', label: 'Approval', value: 'approval', icon: 'approval' },
  { id: '10', label: 'Farmer Journey', value: 'farmer', icon: 'farmer' },
  {
    id: '11',
    label: 'Report and Analytics',
    value: 'reportAnalyse',
    icon: 'reportAnalyse',
  },
  { id: '12', label: 'Settings', value: 'setting/profile', icon: 'setting' },
];

export const ccAuditorMicroApps = [
  { id: '1', label: 'Dashboard', value: 'dashboard', icon: 'dashboard' },
  { id: '2', label: 'Audit Report', value: 'auditor', icon: 'assessment' },
];

export const livelihoodMicroApps = [
  { id: '1', label: 'Dashboard', value: 'livelihood/dashboard', icon: 'dashboard' },
  { id: '2', label: 'Mapping', value: 'livelihood/mapping', icon: 'event' },
  { id: '3', label: 'Events', value: 'livelihood/event', icon: 'event' },
  {
    id: '4',
    label: 'Data Collection',
    value: 'livelihood/datacollection',
    icon: 'reportAdmin',
  },
  { id: '5', label: 'Assessment Report', value: 'livelihood/assessment', icon: 'assessment' },
  { id: '6', label: 'Training', value: 'livelihood/training', icon: 'training' },
  { id: '7', label: 'Program', value: 'livelihood/program', icon: 'survey' },
  { id: '8', label: 'Approval', value: 'livelihood/approval', icon: 'approval' },
  { id: '9', label: 'Farmer Journey', value: 'livelihood/farmer', icon: 'farmer' },
  {
    id: '10',
    label: 'Report and Analytics',
    value: 'livelihood/reportAnalyse',
    icon: 'reportAnalyse',
  },
  { id: '11', label: 'Settings', value: 'setting/profile', icon: 'setting' },
];

export const researchMicroApps = [
  {
    id: '1',
    label: 'Home Dashboard',
    value: 'research/dashboard',
    icon: 'dashboard',
    list: [
      { label: 'Diffusion', value: 'research/diffusion', icon: 'eventAdmin' },
      { label: 'T&V', value: 'research/tv', icon: 'onBoardingAdmin' },
      { label: 'C&C', value: 'research/cc', icon: 'assessment' },
      { label: 'Livelihood Improvement', value: 'research/livelihood', icon: 'farmer' },
    ],
  },
  { id: '2', label: 'Events', value: 'research/event', icon: 'event' },
  {
    id: '3',
    label: 'Data',
    value: 'research/datacollection',
    icon: 'reportAdmin',
    list: [
      { label: 'Diffusion', value: 'research/diffusion', icon: 'eventAdmin' },
      { label: 'T&V', value: 'research/tv', icon: 'onBoardingAdmin' },
      { label: 'C&C', value: 'research/cc', icon: 'assessment' },
      { label: 'Livelihood Improvement', value: 'research/livelihood', icon: 'farmer' },
    ],
  },
  { id: '4', label: 'Survey', value: 'research/survey', icon: 'survey' },
  { id: '5', label: 'Training', value: 'research/training', icon: 'training' },
  {
    id: '6',
    label: 'Report and Analytics',
    value: 'research/reportAnalyse',
    icon: 'reportAnalyse',
  },
  { id: '7', label: 'Farmer Journey', value: 'research/farmer', icon: 'farmer' },
  { id: '8', label: 'Settings', value: 'setting/profile', icon: 'setting' },
];

export const superAdminMicroApps = [
  // { id: '1', label: 'Dashboard', value: 'dashboard', list: [] },
  {
    id: '2',
    label: 'Diffusion',
    value: 'diffusion',
    pillarKey: 'diffusion',
    list: [
      { label: 'Dashboard', value: 'dashboard', icon: 'dashboard' },
      { label: 'Events', value: 'event', icon: 'event' },
      { label: 'Survey', value: 'survey', icon: 'survey' },
      // { label: "Onboarding", value: "onboarding", icon: "onBoardingAdmin" },
      { label: 'Training', value: 'training', icon: 'training' },
      { label: 'Farmer Journey', value: 'farmer', icon: 'farmer' },
      { label: 'Approval', value: 'approval', icon: 'approval' },
      {
        label: 'Report and Analytics',
        value: 'reportAnalyse',
        icon: 'reportAnalyse',
      },
    ],
  },
  {
    id: '3',
    label: 'Traceability & Verification',
    value: 'tv',
    pillarKey: 'traceability_and_verification',
    list: [
      { label: 'Dashboard', value: 'tv/dashboard', icon: 'dashboard' },
      { label: 'Trace', value: 'trace', icon: 'event' },
      // { label: "Compliance", value: "compliance", icon: "trainingAdmin" },
      { label: 'Approval', value: 'tv/approval', icon: 'approval' },
      { label: 'Farmer Journey', value: 'tv/farmer', icon: 'farmer' },
      {
        label: 'Report and Analytics',
        value: 'tv/reportAnalyse',
        icon: 'reportAnalyse',
      },
      // { id: '4', label: "Score Card", value: "scoreCard", icon: "scoreCard" },
    ],
  },
  {
    id: '4',
    label: 'Certification and Compliance',
    value: 'cc',
    pillarKey: 'certification_and_compliance',
    list: [
      { id: '1', label: 'Dashboard', value: 'cc/dashboard', icon: 'dashboard' },

      { id: '2', label: 'Events', value: 'cc/event', icon: 'event' },
      {
        id: '3',
        label: 'Potential ISH',
        value: 'PotentialISH',
        icon: 'survey',
      },
      {
        id: '4',
        label: 'Verification',
        value: 'verification',
        icon: 'verification',
      },
      {
        id: '5',
        label: 'Data Collection',
        value: 'datacollection',
        icon: 'reportAdmin',
      },
      { id: '6', label: 'Assessment', value: 'assessment', icon: 'assessment' },
      {
        id: '6a',
        label: 'LI Assessment Report',
        value: 'li_report',
        icon: 'assessment',
      },
      { id: '7', label: 'Training', value: 'cc/training', icon: 'training' },
      { id: '8', label: 'Audit Report', value: 'auditreport', icon: 'assessment' },
      { id: '9', label: 'Approval', value: 'cc/approval', icon: 'approval' },
      { id: '10', label: 'Farmer Journey', value: 'cc/farmer', icon: 'farmer' },
      {
        id: '11',
        label: 'Report and Analytics',
        value: 'cc/reportAnalyse',
        icon: 'reportAnalyse',
      },
      { id: '12', label: 'Settings', value: 'setting/profile', icon: 'setting' },
    ],
  },
  {
    id: '5',
    label: 'Livelihood improvement',
    value: 'livelihood',
    pillarKey: 'livelihood_improvement',
    list: [
      { id: '1', label: 'Dashboard', value: 'livelihood/dashboard', icon: 'dashboard' },
      { id: '2', label: 'Mapping', value: 'livelihood/mapping', icon: 'event' },
      { id: '3', label: 'Events', value: 'livelihood/event', icon: 'event' },
      {
        id: '4',
        label: 'Data Collection',
        value: 'livelihood/datacollection',
        icon: 'reportAdmin',
      },
      { id: '5', label: 'Assessment Report', value: 'livelihood/assessment', icon: 'assessment' },
      { id: '6', label: 'Training', value: 'livelihood/training', icon: 'training' },
      { id: '7', label: 'Program', value: 'livelihood/program', icon: 'survey' },
      { id: '8', label: 'Approval', value: 'livelihood/approval', icon: 'approval' },
      { id: '9', label: 'Farmer Journey', value: 'livelihood/farmer', icon: 'farmer' },
      {
        id: '10',
        label: 'Report and Analytics',
        value: 'livelihood/reportAnalyse',
        icon: 'reportAnalyse',
      },
      { id: '11', label: 'Settings', value: 'setting/profile', icon: 'setting' },
    ],
  },
  {
    id: '6',
    label: 'Research',
    value: 'research',
    pillarKey: 'research',
    list: [
      { id: '0', label: 'Home', value: 'research/home', icon: 'home' },
      {
        id: '1',
        label: 'Dashboard',
        value: 'research/dashboard',
        icon: 'dashboard',
        list: [
          { label: 'Diffusion', value: 'research/dashboard/diffusion', icon: 'eventAdmin' },
          {
            label: 'Traceability & Verification',
            value: 'research/dashboard/tv',
            icon: 'onBoardingAdmin',
          },
          {
            label: 'Certification and Compliance',
            value: 'research/dashboard/cc',
            icon: 'assessment',
          },
          {
            label: 'Livelihood Improvement',
            value: 'research/dashboard/livelihood',
            icon: 'farmer',
          },
        ],
      },
      { id: '2', label: 'Events', value: 'research/event', icon: 'event' },
      {
        id: '3',
        label: 'Data',
        value: 'research/datacollection',
        icon: 'reportAdmin',
        list: [
          { label: 'Diffusion', value: 'research/diffusionData', icon: 'eventAdmin' },
          {
            label: 'Traceability & Verification',
            value: 'research/tvData',
            icon: 'onBoardingAdmin',
          },
          { label: 'Certification and Compliance', value: 'research/ccData', icon: 'assessment' },
          { label: 'Livelihood Improvement', value: 'research/livelihoodData', icon: 'farmer' },
        ],
      },
      { id: '4', label: 'Survey', value: 'research/survey', icon: 'survey' },
      { id: '5', label: 'Training', value: 'research/training', icon: 'training' },
      {
        id: '6',
        label: 'Report and Analytics',
        value: 'research/reportAnalyse',
        icon: 'reportAnalyse',
      },
      { id: '7', label: 'Farmer Journey', value: 'research/farmer', icon: 'farmer' },
      { id: '8', label: 'Settings', value: 'setting/profile', icon: 'setting' },
    ],
  },
  // { id: '7', label: "Continuous Improvement", value: "continuous", list: [] },
  // { id: '8', label: "Data Management", value: "data-management", list: [] },
  // { id: '9', label: 'User Management', value: 'usermanagement', list: [] },
];

export const userManagementMicroApps = [
  { id: '1', label: 'User Management', value: 'usermanagement', icon: 'usermanagement' },
];

// livelihood headers
//Program Participant Report Columns
export const ProgramParticipantReportCol_LI = [
  { label: 'S.No' },
  { label: 'Farmer Name & Farmer ID', sortable: 'farmerName' },
  { label: 'Farm Id' },
  { label: 'IC Number' },
  { label: 'RISS Group' },
  { label: 'Location' },
];

export const ResearchModuleReportsFilter = [
  {
    title: 'Diffusion',
    type: 'diffusion',
    list: [
      { label: 'S.No', value: 's_no', selected: false },
      { label: 'Farmer Name', value: 'farmer_name', selected: false },
      { label: 'Farm ID', value: 'farm_id', selected: false },
      { label: 'Farmer ID', value: 'farmer_id', selected: false },
      { label: 'Farmer Contact', value: 'farmer_contact', selected: false },
    ],
  },
  {
    title: 'Traceability And Verification',
    type: 'traceability_verification',
    list: [
      { label: 'Land Owner Name', value: 'land_owner_name', selected: false },
      { label: 'Land Owner Occupation', value: 'land_owner_occupation', selected: false },
      { label: 'Owner Age', value: 'owner_age', selected: false },
      { label: 'Owner Gender', value: 'owner_gender', selected: false },
      { label: 'Owner Contact', value: 'owner_contact', selected: false },
      { label: 'Owner IC Number', value: 'owner_ic_number', selected: false },
      { label: 'Owner Address', value: 'owner_address', selected: false },
      {
        label: 'Declaration Form Availability',
        value: 'declaration_form_availability',
        selected: false,
      },
      {
        label: 'Fruit Delivery Agreement Availability',
        value: 'fruit_delivery_agreement_availability',
        selected: false,
      },
      {
        label: 'Relationship Status (Farmer and Landlord)',
        value: 'relationship_status',
        selected: false,
      },
      { label: 'Farm Land Legal Status', value: 'land_legal_status', selected: false },
    ],
  },
  {
    title: 'Farming And Harvest',
    type: 'farming_harvest',
    list: [
      {
        label: 'Relationship Status (Farmer and Landlord)',
        value: 'farming_relationship_status',
        selected: false,
      },
      { label: 'Professional Farmer Status', value: 'professional_farmer_status', selected: false },
      { label: 'MSPO Status', value: 'mspo_status', selected: false },
      { label: 'Lat/Long Values', value: 'coordinates', selected: false },
      { label: 'Planted Area', value: 'planted_area', selected: false },
      { label: 'Harvesting Service', value: 'harvesting_service', selected: false },
      { label: 'Pruning Logic', value: 'pruning_logic', selected: false },
      { label: 'Fertilizer Logic', value: 'fertilizer_logic', selected: false },
      { label: 'Number of trees', value: 'tree_count', selected: false },
      { label: 'Harvest Frequency', value: 'harvest_frequency', selected: false },
      { label: 'FFB Yield (Ton)', value: 'ffb_yield', selected: false },
      { label: 'Fruit Quality', value: 'fruit_quality', selected: false },
      { label: 'FFB Price Per Ton', value: 'ffb_price', selected: false },
      { label: 'FFB Price Source', value: 'ffb_price_source', selected: false },
      { label: 'Oil Content', value: 'oil_content', selected: false },
      { label: 'Fertilizer Type', value: 'fertilizer_type', selected: false },
      { label: 'FFB Grade', value: 'ffb_grade', selected: false },
      { label: 'Estimated Harvest Date', value: 'estimated_harvest_date', selected: false },
      { label: 'Actual Harvest Date', value: 'actual_harvest_date', selected: false },
      { label: 'Current Yield', value: 'current_yield', selected: false },
      { label: 'Average Fruit Weight', value: 'avg_fruit_weight', selected: false },
      { label: 'Fruit Set Percentage', value: 'fruit_set_percentage', selected: false },
      { label: 'Pest Identification', value: 'pest_id', selected: false },
      { label: 'Disease Identification', value: 'disease_id', selected: false },
      { label: 'FFB Volume (Per Trip)', value: 'ffb_volume', selected: false },
      { label: 'Transport Mode', value: 'transport_mode', selected: false },
      { label: 'Distance To Mill', value: 'mill_distance', selected: false },
      { label: 'Price Premium Paid', value: 'price_premium', selected: false },
      { label: 'Waste Management', value: 'waste_management', selected: false },
      { label: 'Water Source For Irrigation', value: 'water_source', selected: false },
      { label: 'Labour Availability', value: 'labour_availability', selected: false },
      { label: 'Labour Cost Per Month', value: 'labour_cost', selected: false },
      { label: 'Total Farm Expenses', value: 'total_expenses', selected: false },
      { label: 'Net Farm Income', value: 'net_income', selected: false },
      { label: 'Farmer Perception of Yield', value: 'yield_perception', selected: false },
      { label: 'FFB Grade Distribution', value: 'grade_distribution', selected: false },
      { label: 'Harvesting Efficiency', value: 'harvest_efficiency', selected: false },
      { label: 'Soil Type', value: 'soil_type', selected: false },
      { label: 'Soil Ph Value', value: 'soil_ph', selected: false },
      { label: 'Leaf Analysis Status', value: 'leaf_analysis', selected: false },
      { label: 'Soil Analysis Status', value: 'soil_analysis', selected: false },
      { label: 'E-Wallet Implementation Status', value: 'e_wallet_status', selected: false },
    ],
  },
  {
    title: 'Yield and Improvement',
    type: 'yield_improvement',
    list: [
      { label: 'Yield Improvement Strategy', value: 'improvement_strategy', selected: false },
      { label: 'Farmer Trust', value: 'farmer_trust', selected: false },
      { label: 'FFB Price Per Ton', value: 'yield_ffb_price', selected: false },
      { label: 'Fruit Quality', value: 'yield_fruit_quality', selected: false },
      { label: 'Pruning', value: 'yield_pruning', selected: false },
      { label: 'Fertilizing', value: 'yield_fertilizing', selected: false },
      { label: 'Number of trees (Mature)', value: 'mature_trees', selected: false },
      { label: 'Total Farm Area', value: 'total_area', selected: false },
      { label: 'Fertilizer Application Date', value: 'fertilizer_date', selected: false },
      { label: 'Estimated Yield', value: 'estimated_yield', selected: false },
      { label: 'FFB Quality Check', value: 'quality_check', selected: false },
      { label: 'Transport Cost', value: 'transport_cost', selected: false },
      { label: 'E-Wallet Transaction ID', value: 'transaction_id', selected: false },
      { label: 'Payment Status', value: 'payment_status', selected: false },
      { label: 'Collection Center ID', value: 'collection_id', selected: false },
      { label: 'Agent Name', value: 'agent_name', selected: false },
    ],
  },
];

export const PillarTabs = [
  { label: 'Diffusion', value: DIFFUSION },
  { label: 'Traceability & Verification', value: TV },
  { label: 'Certifications & Compliance', value: CC },
  { label: 'Livelihood Improvement', value: LIVELIHOOD },
];

export const ResearchParticipantsHeaders = [
  { label: 'S.No' },
  { label: 'Farmer ID' },
  { label: 'Farmer Name', sortable: 'name' },
  { label: 'Gender' },
  { label: 'Training Mode' },
  { label: 'View Details' },
];
export const ResearchTVParticipantsHeaders = [
  { label: 'S.No' },
  { label: 'Farmer ID' },
  { label: 'Farm ID' },
  { label: 'Farmer Name', sortable: 'name' },
  { label: 'Traceability status' },
  { label: 'Gender' },
  { label: 'Organisation' },
  { label: 'View Details' },
  { label: 'View Documents' },
];

export const ResearchLIParticipantsHeaders = [
  { label: 'S.No' },
  { label: 'Farmer ID', sortable: 'farmerId' },
  { label: 'Farmer Name', sortable: 'farmerName' },
  { label: 'Farm ID', sortable: 'farmId' },
  { label: 'RISS Group', sortable: 'rissGroupNames' },
  { label: 'Collection Centre', sortable: 'collectionCenterName' },
  { label: 'Gender' },
  // { label: 'Training Mode', sortable: 'eventMode' },
  // { label: 'Organisation', sortable: 'organisationName' },
  { label: 'Event Name', sortable: 'eventName' },
  { label: 'Program Enrolled', key: 'programEnrolled' },
  { label: 'View Details' },
];

export const ResearchCCParticipantsHeaders = [
  { label: 'S.No' },
  { label: 'Farmer ID', sortable: 'farmerId' },
  { label: 'Farmer Name', sortable: 'name' },
  { label: 'RISS Group', sortable: 'rissGroupName' },
  { label: 'Collection Centre', sortable: 'collectionCenter' },
  { label: 'RISS Status', sortable: 'rissStatus' },
  { label: 'Location', sortable: 'location' },
  { label: 'Gender', sortable: 'gender' },
  { label: 'Training Mode', sortable: 'trainingMode' },
  { label: 'View Details' },
];

export const ResearchTVDashboardTabs = [
  { label: 'Farmer Details', value: 'farmer' },
  { label: 'Farm Details', value: 'farm' },
  { label: 'Worker Details', value: 'worker' },
];

export const ResearchDFDashboardTabs = [
  { label: 'Diffusion', value: 'diffusion' },
  { label: 'Demographic Data', value: 'demographic_data' },
  { label: 'Pre - Survey', value: 'pre_survey' },
  { label: 'Post - Survey', value: 'post_survey' },
  { label: 'Post 3 month Survey', value: 'post_3_month_survey' },
];

export const ResearchCCDashboardTabs = [
  { label: 'Farmer Details', value: 'farmer_details' },
  { label: 'Farm Details', value: 'farm_details' },
  { label: 'Monthly Data', value: 'monthly_data' },
  { label: 'Worker Details', value: 'worker_details' },
  { label: 'Premium Calculation', value: 'premium_calculation' },
];

export const ResearchLIDashboardTabs = [
  { label: 'Program Details', value: 'program_details' },
  { label: 'Farmer Details', value: 'farmer_details' },
  { label: 'Farm Details', value: 'farm_details' },
  { label: 'FFB Yield', value: 'ffb_yield' },
  { label: 'GQA Score', value: 'gqa_score' },
  { label: 'GQA Farm Maintenance', value: 'gqa_farm_maintenance' },
  { label: 'Fertilizer Recommendation', value: 'fertilizer_recommendation' },
  { label: 'Fertilizer Application', value: 'fertilizer_application' },
  { label: 'Profitability', value: 'profitability' },
  { label: 'Soil Analysis', value: 'soil_analysis' },
  { label: 'Plant Analysis', value: 'plant_analysis' },
  { label: 'Trunk Analysis', value: 'trunk_analysis' },
  { label: 'VGM Sampling', value: 'vgm_sampling' },
  { label: 'Ganoderma Census', value: 'ganoderma_census' },
];

export const PILLAR_KEY_MAP = {
  certification_and_compliance: 'cc',
  livelihood_improvement: 'li',
  traceability_and_verification: 'tv',
  diffusion: 'df',
};
